/**
 * The requests whose server side records a shadow-mode risk event and asks
 * BotID and Fingerprint about it (apps/web/src/lib/risk-events.ts and the
 * riskEvent tRPC middleware). checkBotId() on a route missing here reads as a
 * bot, and the server finds no Fingerprint event for it, so this list and the
 * server call sites change together.
 *
 * tRPC paths are wildcarded on both sides because httpBatchLink puts every
 * procedure of a batch into one path segment. `*` matches any run of
 * characters, the same as BotID's own matcher.
 */
export const RISK_EVENT_ROUTES = [
  { path: "/api/auth/sign-in/magic-link", method: "POST" },
  { path: "/api/trpc/*applyFlow.enterApplication*", method: "POST" },
  { path: "/api/trpc/*user.sendPhoneVerification*", method: "POST" },
  { path: "/api/trpc/*user.createVIOrder*", method: "POST" },
  { path: "/api/trpc/*user.createWhopPayout*", method: "POST" },
];

const ROUTE_PATTERNS = RISK_EVENT_ROUTES.map(({ path, method }) => ({
  method,
  pattern: new RegExp(
    `^${path.replace(/[.?+^$[\]\\(){}|-]/g, "\\$&").replaceAll("*", ".*")}$`,
  ),
}));

export function isRiskEventRoute(pathname: string, method: string): boolean {
  const upperMethod = method.toUpperCase();
  return ROUTE_PATTERNS.some(
    (route) => route.method === upperMethod && route.pattern.test(pathname),
  );
}
